import React from "react";
import PropTypes from "prop-types";
import {FixedTopBar} from "../fixed-top-bar";
import styles from "./vehicle-image-top-bar.module.scss";

export const VehicleImageTopBar = ({imageUrl}) => (
    <FixedTopBar>
        <header className={`${styles.header} spark-bg-white spark-shadow-element`}>
            <img src={imageUrl} alt="Vehicle selected for financing" />
        </header>
    </FixedTopBar>
);

VehicleImageTopBar.propTypes = {
    imageUrl: PropTypes.string.isRequired,
};
